import React from "react";
import portfoliopic from "../../img/portfoliopic.jpeg";
const Intro = () => {
  return (
    <>
      <div className="i">
        <div className="i-left-wrapper">
          <h2 className="i-intro">Hello,MY name is</h2>
          <h1 className="i-name">Happy</h1>
          <div className="i-title">
            <div className="i-title-wrapper">
              <div className="i-title-item">Web Developer</div>
              <div className="i-title-item">Software engineer</div>
              <div className="i-title-item">Android Developer</div>
              <div className="i-title-item">Software Developer</div>
            </div>
          </div>
          <div className="i-desc">
            B.tech Final year student of computer Science &Engineering in
            Maharshi Dayanand University,Rohtak,India.I design and develop
            services for customers of all sizes,specializing in creating
            stylish,modern websites.
          </div>
        </div>

        <div className="i-right">
          <div className="i-bg"></div>
          <img src={portfoliopic} alt="" className="i-img" />
        </div>
      </div>
    </>
  );
};

export default Intro;
